import React from 'react';
import { Link } from 'react-router-dom';

function ProcessingPage() {
  return (
    <div className="min-h-screen bg-muted text-foreground">
      
      <div className="flex items-center justify-center min-h-screen">
        <h1 className="text-4xl font-bold">We have Processed your Booking</h1>
      </div>
    </div>
  );
}

export default ProcessingPage;
